import FormControlLabel from '@mui/material/FormControlLabel';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSecondOwnerInfo } from '../../redux-state/selectors';
import { UPDATE_SECOND_OWNER_INFO } from '../../redux-state/forms/types';

function SecondOwnerInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(false);
  const secondOwnerInfo = useSelector(selectSecondOwnerInfo);
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_SECOND_OWNER_INFO,
      payload: { key, value },
    });
  };

  return (
    <div>
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">Second Owner Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Show Detail' : 'Hide Detail'}</div>
          <div>
            <FormControlLabel
              control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
            />
          </div>
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="secondOwnerFirstName"
              label="Secondary Owner First Name"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerFirstName || ''}
              onChange={(e) => handleChange('secondOwnerFirstName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="secondOwnerMiddleName"
              label="Secondary Owner Middle Name"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerMiddleName || ''}
              onChange={(e) => handleChange('secondOwnerMiddleName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="secondOwnerLastName"
              label="Secondary Owner Last Name"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerLastName || ''}
              onChange={(e) => handleChange('secondOwnerLastName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="secondOwnerPhoneNumber"
              label="Owner Phone Number"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerPhoneNumber || ''}
              onChange={(e) => handleChange('secondOwnerPhoneNumber', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="secondOwnerCompanyName"
              label="Secondary Owner Company Name (if applicable)"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerCompanyName || ''}
              onChange={(e) => handleChange('secondOwnerCompanyName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="secondOwnerAddressLine1"
              label="Secondary Owner Address Line 1"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerAddressLine1 || ''}
              onChange={(e) => handleChange('secondOwnerAddressLine1', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="secondOwnerAddressLine2"
              label="Secondary Owner Address Line 2"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerAddressLine2 || ''}
              onChange={(e) => handleChange('secondOwnerAddressLine2', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="secondOwnerCity"
              label="Secondary Owner City"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerCity || ''}
              onChange={(e) => handleChange('secondOwnerCity', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="secondOwnerState"
              label="Secondary Owner State"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerState || ''}
              onChange={(e) => handleChange('secondOwnerState', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="secondOwnerCountry"
              label="Secondary Owner County"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerCountry || ''}
              onChange={(e) => handleChange('secondOwnerCountry', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="secondOwnerZip"
              label="Secondary Owner Zip"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerZip || ''}
              onChange={(e) => handleChange('secondOwnerZip', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="secondOwnerDob"
              label="Secondary Owner Date of Birth"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerDob || ''}
              onChange={(e) => handleChange('secondOwnerDob', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="secondOwnerSsn"
              label="Secondary Owner SSN"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerSsn || ''}
              onChange={(e) => handleChange('secondOwnerSsn', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="secondOwnerLicenseNumber"
              label="Secondary Owner Driver's License Number"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerLicenseNumber || ''}
              onChange={(e) => handleChange('secondOwnerLicenseNumber', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="secondOwnerLicenseState"
              label="Secondary Owner Driver's License State"
              variant="outlined"
              className="flex-1"
              value={secondOwnerInfo?.secondOwnerLicenseState || ''}
              onChange={(e) => handleChange('secondOwnerLicenseState', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default SecondOwnerInformation;
